/** @jsxImportSource @emotion/react */
import React from 'react';
import { View } from 'react-native-web';
import { IProductCategory } from '@ddot/AddToCartCommon/lib/entities/ProductCategory';
import { useAppSelector } from 'Redux/hooks';
import Selectors from '../../Redux/Selectors';
import {
    wrapper1,
    wrapper2,
    cont1,
    linkWrapper,
    GITItems,
} from '../Styles/FooterMobileStyle';
import PackageJson from '../../../package.json';
import Accordian from './Accordian';

const Footer = (): JSX.Element => {
    const listProductsCategories = useAppSelector(Selectors.getProductsCategories);

    const categoryName = listProductsCategories.map((item: IProductCategory) => {
        // const nameOnly = item.name.replace(/(.*)-/, '').toLocaleLowerCase();
        return item.name;
    });

    const accrodianData = [
        {
            title: 'All Pages',
            content: [
                'Products',
                'About Us',
                'Career',
                'Contact Us',
            ],
            link: [
                `${process.env.REACT_APP_BASE_URL}/categories`,
                `${process.env.REACT_APP_BASE_URL}/about-us`,
                `${process.env.REACT_APP_BASE_URL_OLD}/career/`,
                `${process.env.REACT_APP_BASE_URL_OLD}/contact-us/`,
            ],
        },
        {
            title: 'Products',
            content: categoryName,
        },
        {
            title: 'Support',
            content: [
                'FAQ',
                'Shipping & Returns',
                'Privacy Policy',
                'Terms of Service',
            ],
            link: [
                `${process.env.REACT_APP_BASE_URL_OLD}/faqs`,
                `${process.env.REACT_APP_BASE_URL_OLD}/shipping-returns`,
                `${process.env.REACT_APP_BASE_URL_OLD}/privacy-policy`,
                `${process.env.REACT_APP_BASE_URL_OLD}/terms-of-service`,
            ],
        },
        {
            title: 'Get in Touch',
            content: [
                '75, Jalan Austin Heights 3, Taman Mount Austin, 81100 Johor Bahru, Johor, Malaysia.',
                '+60 16-773 0338',
                'online@tiansi.my',
            ],
            img: [
                'assets/icons/Phone.png',
                'assets/icons/location.png',
                'assets/icons/email.png',
            ],
        },
    ];

    return (
        <View>
            <div css={wrapper1}>
                <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '15%' }}>
                    <div style={{ width: '40%' }}>
                        <img src='/Logo.png' alt='logo' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                    </div>
                </div>

                <div css={cont1}>
                    {
                        accrodianData.map((item) => {
                            return (
                                <Accordian key={item.title} title={item.title} content={item.content} link={item.link ?? undefined} />
                            );
                        })
                    }
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 20, paddingTop: 25 }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <a href='https://tinyurl.com/TianSiJewellery' target='_blank' rel='noreferrer'>
                            <p style={{ color: 'white', fontFamily: 'AcuminRPro', fontSize: '1.1rem', margin: 0 }}>TIANSI JEWELLERY</p>
                        </a>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <a href='https://tinyurl.com/Facebook-TianSiJewellery' target='_blank' rel='noreferrer' aria-label='visit facebook'>
                                <img src='/assets/icons/Facebook1.svg' alt='' style={{ height: 20, width: 20 }} />
                            </a>
                            <a href='https://tinyurl.com/XHS-TianSiJewellery' target='_blank' rel='noreferrer' aria-label='visit xiaohongshu'>
                                <img src='/assets/icons/XiaoHongShu1.svg' alt='' style={{ height: 20, width: 20 }} />
                            </a>
                            <a href='https://tinyurl.com/WAChannel-TianSiJewellery' target='_blank' rel='noreferrer' aria-label='visit whatsapp'>
                                <img src='/assets/icons/whatsapp.png' alt='' style={{ height: 17, width: 17, marginTop: 2 }} />
                            </a>
                            <a href='https://tinyurl.com/ShopNow-TianSiJewellery' target='_blank' rel='noreferrer' aria-label='visit shop'>
                                <img src='/assets/icons/shopping-bag.png' alt='' style={{ height: 18, width: 18 }} />
                            </a>
                            {/* <a href='https://www.youtube.com/@tiansijewellery4693' target='_blank' rel='noreferrer' aria-label='visit youtube'>
                                        <img src='/assets/icons/YouTube1.svg' alt='' style={{ height: 20, width: 20 }} />
                                    </a> */}
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <a href='https://tiansi.my/tiansi-hipine-gold-watch-malaysia/' target='_blank' rel='noreferrer'>
                            <p style={{ color: 'white', fontFamily: 'AcuminRPro', fontSize: '1.1rem', margin: 0 }}>HIPINE MALAYSIA</p>
                        </a>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <a href='https://www.facebook.com/HIPINEMalaysia' target='_blank' rel='noreferrer' aria-label='visit facebook'>
                                <img src='/assets/icons/Facebook1.svg' alt='' style={{ height: 20, width: 20 }} />
                            </a>
                            <a href='https://www.instagram.com/hipine_malaysia/' target='_blank' rel='noreferrer' aria-label='visit instagram'>
                                <img src='/assets/icons/Instagram1.svg' alt='' style={{ height: 20, width: 20 }} />
                            </a>
                            <a href='https://www.xiaohongshu.com/user/profile/64db3109000000000100f95d?xsec_token=ABcNZezSzSbihVImV0ObtNmhIWBbUhHWChfChfLOrM8Jo%3D&xsec_source=pc_search' target='_blank' rel='noreferrer' aria-label='visit xiaohongshu'>
                                <img src='/assets/icons/XiaoHongShu1.svg' alt='' style={{ height: 20, width: 20 }} />
                            </a>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <p style={{ color: 'white', fontFamily: 'AcuminRPro', fontSize: '1.1rem', margin: 0 }}>JIWA TUAH</p>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <a href='https://www.facebook.com/JiwaTuahMalaysia/' target='_blank' rel='noreferrer' aria-label='visit facebook'>
                                <img src='/assets/icons/Facebook1.svg' alt='' style={{ height: 20, width: 20 }} />
                            </a>
                        </div>
                    </div>
                </div>

                {/* <div style={{ display: 'flex', gap: 10, justifyContent: 'center', paddingTop: 20 }}>
                    <a href='https://www.instagram.com/tiansi.jewellery/' target='_blank' rel='noreferrer' aria-label='visit instagram'>
                        <img src='/assets/icons/Instagram1.svg' alt='' style={{ height: 20, width: 20 }} />
                    </a>
                    <a href='https://www.facebook.com/TianSiJeweIIery' target='_blank' rel='noreferrer' aria-label='visit facebook'>
                        <img src='/assets/icons/Facebook1.svg' alt='' style={{ height: 20, width: 20 }} />
                    </a>
                    <a href='https://www.tiktok.com/@tiansijewellery' target='_blank' rel='noreferrer' aria-label='visit tiktok'>
                        <img src='/assets/icons/Tiktok1.svg' alt='' style={{ height: 20, width: 20 }} />
                    </a>
                    <a href='https://www.youtube.com/@tiansijewellery4693' target='_blank' rel='noreferrer' aria-label='visit youtube'>
                        <img src='/assets/icons/YouTube1.svg' alt='' style={{ height: 20, width: 20 }} />
                    </a>
                    <a href='https://www.xiaohongshu.com/user/profile/64676fa5000000002b009ccb' target='_blank' rel='noreferrer' aria-label='visit xiaohongshu'>
                        <img src='/assets/icons/XiaoHongShu1.svg' alt='' style={{ height: 20, width: 20 }} />
                    </a>
                </div> */}

                <p style={{ color: '#8CB5C9', fontFamily: 'AcuminRPro', fontSize: '1.1rem', margin: 0, textAlign: 'center', paddingTop: 20, paddingBottom: 20 }}>© 2024 Kedai Emas Tian Si Sdn. Bhd. (1100830-K) All Rights Reserved.</p>
            </div>
        </View>
    );
};

export default Footer;
